import { Routes } from '@angular/router';
import { SwaggerDashboardComponent } from './shared/lib/swagger-auth/components/dashboard/dashboard.component';
import { SwaggerLoginComponent } from './shared/lib/swagger-auth/components/login/login.component';
import { SwaggerNotFoundComponent } from './shared/lib/swagger-auth/components/not-found/not-found.component';
import { SwaggerUnauthorizedComponent } from './shared/lib/swagger-auth/components/unauthorized/unauthorized.component';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'ui/login',
    component: SwaggerLoginComponent
  },
  {
    path: 'ui/dashboard',
    component: SwaggerDashboardComponent
  },
  {
    path: 'ui/unauthorized',
    component: SwaggerUnauthorizedComponent
  },
  {
    path: 'ui/notfound',
    component: SwaggerNotFoundComponent
  },
  {
    path: 'ui/404',
    redirectTo: 'ui/notfound'
  },
  {
    path: 'ui/403',
    redirectTo: 'ui/unauthorized'
  },
  {
    path: '**',
    component: SwaggerNotFoundComponent
  }
];
